import { Component, Input, OnInit, ViewChild, ElementRef, AfterViewInit, Output, EventEmitter } from '@angular/core';
import { Workshop } from 'src/models/workshop';
import { brands } from "src/services/api-services/api-interfaces/brands.interface";

@Component({
    selector: 'app-carousel',
    templateUrl: './carousel.component.html',
    styleUrls: ['./carousel.component.sass'],
    standalone: false
})
  export class CarouselComponent  implements OnInit, AfterViewInit {
    @ViewChild('scrollableContent') scrollableContent!: ElementRef;
    @Input() recievedArray?: any[]
    @Output() brand: EventEmitter<brands | Workshop> =  new EventEmitter<brands | Workshop>();
    ngOnInit(): void {
        //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
        //Add 'implements OnInit' to the class.
        
      }
      ngAfterViewInit() {
        // El código aquí se ejecutará después de que la vista y los elementos se hayan inicializado
        // Puedes acceder a this.scrollableContent aquí
      }
      selectedStyle = {
        background: '#F7F8FA',
        'border-bottom': 'solid 2px  #19BEE7 ',
        color: '#19BEE7',
        display: 'flex',
        'align-items': 'center',
        'justify-content': 'center',
        'font-size': '16px',
        'font-family': 'sans-serif',
        'border-radius': '0',
      };
      unselectedStyle = {
        background: '#F7F8FA',  
        color: '#000',
        display: 'flex',
        'align-items': 'center',
        'justify-content': 'center',
        'font-size': '16px',
        'font-family': 'sans-serif',
        'border-radius': '0',
      };

      
      scroll:number = 0;
      scrollToRight() {
        if (this.scrollableContent) {
            this.scroll+= 400
            this.scrollableContent.nativeElement.scrollLeft = this.scroll 
          }
      }
      scrollToLeft(){
        if (this.scrollableContent) {
            this.scroll-= 400
            this.scrollableContent.nativeElement.scrollLeft = this.scroll 
          }
      }
      sendBrand(brand:brands| Workshop, index:number){
        this.brand.emit(brand)
        this.recievedArray?.forEach((item, i) => {
            item.style = this.unselectedStyle;
            if (i === index) {
              item.style = this.selectedStyle;
            }
          });
      }
  }
